import { Api } from './api'

/**
 * Microsoft Graph with the Microsoft access token from the last Microsoft
 * sign-in (`@ofc:msAccessToken`), never the Firebase session token. It is not
 * refreshed: once it expires Graph calls fail and callers fall back.
 */
class Microsoft extends Api {
    constructor() {
        super('https://graph.microsoft.com/v1.0', '@ofc:msAccessToken')
    }
}

export const MAPI = new Microsoft()
